import templateUrl from 'emun.shopping.admin/event-notifications.htm'
class EventNotificationsController {
    constructor($rootScope, createAutoQuery, $window) { 
        var scope = this;
        $rootScope.$on('customerNoteSaved', () => this.eventLogs.load(true));
        $rootScope.$on('activitySaved', () => this.eventLogs.load(true));
        var url = 'QueryEventLogs.json?onlyNotifications=1&';
        if (this.customerId) {
            url = url + '&retailerId=' + this.customerId;
        } else if (this.repId) {
            url = url + '&salesrepId=' + this.repId;
        }
        this.eventLogs = createAutoQuery({
            url: url,
            orderBy: '-DateTime',
            autoLoad: true,
            pageSize: 100
        })
    }
}

let EventNotifications = {
    bindings: {
        customerId: '<',
        repId: '<'
    },
    controller: EventNotificationsController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

angular.module('emun.shopping.admin').component('eventNotifications', EventNotifications);

export default EventNotifications